import { FaBox } from "react-icons/fa";
import { DateRangeFilter } from "../reportSummary/DateRangeFilter";

export function PackageDashboardHeader({ timeRange, onTimeRangeChange }) {
  return (
    <div className="flex items-center justify-between gap-3">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg bg-[#1E61DC]/10 flex items-center justify-center">
          <FaBox className="w-6 h-6 text-[#1E61DC]" />
        </div>
        <div>
          <span className="text-[#1A1A1A] text-xl">
            Packages Revenue Dashboard
          </span>
          <p className="text-[#6B7280]">
            Complete vacation packages and bundled offerings
          </p>
        </div>
      </div>
      <DateRangeFilter value={timeRange} onChange={onTimeRangeChange} />
    </div>
  );
}
